module.exports = __webpack_public_path__ + "static/media/magne.487c0354.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/magne.svg
// module id = 294
// module chunks = 0